module.exports = __webpack_public_path__ + "static/img/ca760e50409c796a4e770c54554f92bf.ca760e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/item/ca760e50409c796a4e770c54554f92bf.jpg
// module id = vXrD
// module chunks = 0